import { HeartBank } from "../../../managers/HeartBank.ts";
import template from "./hb-x.mjs";
import { render } from "lit-html";
import { User } from "firebase/auth";
import {
    B,
    pickFile,
    getHero,
    downloadFile,
    isUSDZ,
    isProduction,
    wait,
    defaults,
    fetchBlob
} from "../../global.ts";
import { Chests } from "../../../models/Chests.ts";
import { Gif } from "./Gif.ts";
import { Crystal3B } from "../../../models/Crystal.ts";
import { B3 } from "../../../models/3B.ts";
import { HbB } from "../hb-b/hb-b.ts";
import { Functions } from "../../../managers/Functions.ts";
import { Me } from "../../../managers/Me.ts";
import { Chest } from "../../../managers/Chest.ts";
import { Media } from "../../../managers/Media.ts";

import { Modal } from "flowbite";
import type { ModalOptions, ModalInterface } from "flowbite";
import type { InstanceOptions } from "flowbite";
import { HbDialog } from "../hb-dialog/hb-dialog.ts";
import { HbMain } from "../hb-main.ts";

//import Strings from "../../../models/Strings.json";
//const strings: any = Strings;

export class HbX extends HTMLElement {
    private heartbank: HeartBank = new HeartBank();
    private media = new Media();
    private functions = new Functions();
    private chests = new Chests();
    private me = new Me();
    private B = new B3();
    private gif: Gif;
    private crystal: Crystal3B;
    private modal: ModalInterface;
    private dialog: HbDialog;
    private main = document.querySelector("hb-main") as HbMain; // for email spinner

    private chest: any;
    private data: any;

    private x: HTMLElement;
    private b1: HbB;
    private b2: HTMLPictureElement;
    private b: HTMLCanvasElement; // 2b chest
    private b3: HTMLCanvasElement; // 3b crystal
    private message: HTMLParagraphElement;

    private buryBtn: HTMLButtonElement;
    private createBtn: HTMLButtonElement;
    private shipBtn: HTMLButtonElement;
    private shareBtn: HTMLButtonElement;
    private courierBtn: HTMLButtonElement;
    private vaultBtn: HTMLButtonElement; // deprecated
    private closeBtn: HTMLButtonElement;

    private cash: HTMLElement;
    private karat: HTMLElement;
    private carat: HTMLElement;
    private povBtn: HTMLButtonElement;
    private pov: "Public" | "Recipient" | "Sender" = "Public";

    private readonly link = "https://vault.333.eco/#/mine";

    constructor() {
        super();
        render(template(null), this);

        this.dialog = this.querySelector("hb-dialog")!;
        this.x = this.querySelector("#hb-x")!;
        this.b1 = this.querySelector("hb-b")!; // weird bug like in main
        this.b2 = this.querySelector("#hb-x-b2")!; // weird bug: can't do "picture"
        this.b = this.querySelector("#hb-x-b")!;
        this.b3 = this.querySelector("#hb-x-3b")!;
        this.message = this.querySelector("#hb-x-message")!;

        this.buryBtn = this.querySelector("#hb-x-bury")!;
        this.createBtn = this.querySelector("#hb-x-create")!;
        this.shipBtn = this.querySelector("#hb-x-ship")!;
        this.shareBtn = this.querySelector("#hb-x-share")!;
        this.courierBtn = this.querySelector("#hb-x-courier")!;
        this.vaultBtn = this.querySelector("#hb-x-vault")!;
        this.closeBtn = this.querySelector("#hb-x-close")!;

        this.cash = this.querySelector("#hb-x-cash")!;
        this.karat = this.querySelector("#hb-x-karat")!;
        this.carat = this.querySelector("#hb-x-carat")!;
        this.povBtn = this.querySelector("#hb-x-pov")!;

        this.gif = new Gif(this.b);
        this.crystal = new Crystal3B(this.b3);

        const modalOptions: ModalOptions = {
            placement: "center",
            backdrop: "dynamic",
            backdropClasses:
                "bg-gray-900/50 dark:bg-gray-900/80 fixed inset-0 z-40",
            closable: true,
            onHide: () => {
                this.gif.stopAnimation();
                this.crystal.stopAnimation();
            },
            onShow: () => {
                //console.log("modal is shown");
            },
            onToggle: () => {
                //console.log("modal has been toggled");
            }
        };

        // instance options object
        const instanceOptions: InstanceOptions = {
            id: "hb-x",
            override: true
        };

        this.modal = new Modal(this.x, modalOptions, instanceOptions);
    }

    connectedCallback() {
        this.b1.addEventListener("click", this.preview.bind(this));
        this.b2.addEventListener("click", this.preview.bind(this));
        //this.message.addEventListener("click", this.preview.bind(this));

        this.buryBtn.addEventListener("click", this.bury.bind(this)); // this.dialog2.showModal(); // cannot do bind;
        this.createBtn.addEventListener("click", this.create.bind(this));
        // this.dialog2.addEventListener(
        //     "close",
        //     this.create.bind(this, this.dialog.returnValue)
        // );

        this.shipBtn.addEventListener("click", () => {
            this.ship();
        });
        this.shareBtn.addEventListener("click", this.share.bind(this));

        this.courierBtn.addEventListener("click", () => {
            // if (
            //     confirm(
            //         "Would you like to ask someone to anonymously forward your HeartBank® Chest on your behalf?"
            //     )
            // ) // interruption causes error
            this.courier();
        });
        this.vaultBtn.addEventListener("click", async () => {
            window.location.hash = "#/vault/mint";
        });

        this.closeBtn.addEventListener("click", async () => {
            window.location.hash = "#/vault/mint";
        });

        this.querySelectorAll<HTMLInputElement>("input[name=hb-x-pov]").forEach(
            (radio) => {
                radio.addEventListener("change", () => {
                    const pov = this.querySelector<HTMLInputElement>(
                        "input[name=hb-x-pov]:checked"
                    );
                    switch (pov?.value) {
                        case "public":
                            this.pov = "Public";
                            break;
                        case "recipient":
                            this.pov = "Recipient";
                            break;
                        case "sender":
                            this.pov = "Sender";
                            break;
                    }
                    this.message.textContent = this.renderMessage();
                    this.message.style.color = "gray";
                    this.povBtn.click();
                });
            }
        );

        this.heartbank.addAuthStateListener((user) => {
            //render(template(user), this);
            this.render(user);
        });
    }

    private preview() {
        window.location.hash = `#/chest/${this.chest.id}/mint`;
    }

    private renderMessage() {
        let pov;
        switch (this.pov) {
            case "Public":
                pov = "the Public's";
                break;
            case "Recipient":
                pov = "your Recipient's";
                break;
            case "Sender":
                pov = "your";
                break;
        }
        switch (this.data.b.v) {
            case 0: // cloud
                return `Tap on Silver B-Chest to open from ${pov} point of view`;
            case 1: // code
                return `Tap on Silver QR Code to open from ${pov} point of view`;
            case 2: // crystal
                return `Tap on Silver 3B Crystal to open from ${pov} point of view`;
        }
        return "";
    }

    render(user: User | null) {
        const features = user
            ? JSON.parse(getHero().features || "{}")
            : JSON.parse(localStorage.getItem("features") || "{}");
        const ar = features.ar || defaults.ar;
        const arButtons = this.querySelector("#hb-x-ar") as HTMLElement;

        if (ar) {
            arButtons.classList.remove("hidden");
            arButtons.classList.add("flex");
        } else {
            arButtons.classList.add("hidden");
            arButtons.classList.remove("flex");
        }

        //this.shareBtn.classList.toggle("w-36", !!user);
        //this.shareBtn.classList.toggle("w-full", !user);
        this.shipBtn.classList.toggle("hidden", !user);
        this.shareBtn.innerHTML = user
            ? "Share <br class='lg:hidden'> Publicly"
            : "Share Publicly";
    }

    // TODO: show spinner if await is too long
    async show(id: string) {
        this.modal.show();
        if (!id && this.chest && this.data) {
            // restart animation
            // switch (this.data.b.v) {
            //     case 0:
            //         if (this.data.b.s) this.gif.startAnimation();
            //         break;
            //     case 1:
            //         if (this.data.b.s) this.gif.startAnimation();
            //         break;
            //     case 2:
            //         this.crystal.startAnimation(!!this.data.b.s);
            //         break;
            // }
        } else {
            this.dialog.show("chest");

            this.chest = await this.chests.get(
                id || localStorage.getItem("chest")!
            );
            this.data = JSON.parse(
                decodeURIComponent(this.chest.data.split("/")[1] || "{}")
            );

            this.b1.karat = "silver";
            this.b1.rainbow = false;
            this.b1.heartbeat = !!this.data.b.s;

            const karat = this.karat.parentElement
                ?.lastElementChild as HTMLSpanElement;
            const karatIcon = this.karat.parentElement
                ?.firstElementChild as SVGElement;
            this.karat.textContent = this.data.b.w || 0;
            karat.textContent = this.data.n.v ? "Karat Gold" : "Karat Silver";
            karatIcon.classList.toggle("fill-gray-500", !this.data.n.v);
            karatIcon.classList.toggle("dark:fill-gray-400", !this.data.n.v);
            karatIcon.classList.toggle("fill-yellow-500", this.data.n.v);

            this.carat.textContent = this.data.b.d || 0;
            this.cash.textContent =
                this.data.g && this.data.g.a > 0
                    ? this.data.g.a.toCashAmount()
                    : "$0"; // TODO: later add currency

            const cash = this.cash.parentElement?.parentElement as HTMLElement;
            cash.classList.toggle(
                "hidden",
                !(this.data.g && this.data.g.a > 0)
            );

            const carat = this.carat.parentElement as HTMLSpanElement;
            carat.classList.toggle("hidden", !this.data.b.d);
            carat.classList.toggle("inline-flex", !!this.data.b.d);

            const section = carat.parentElement as HTMLElement;
            section.classList.toggle("justify-center", !this.data.b.d);
            section.classList.toggle("justify-between", !!this.data.b.d);

            const qrMessage =
                "Now engraving a unique QR Code on your Silver B-Chest for easy sharing...";
            const skipMessage =
                "Skipping creation of a Short Link for your Silver B-Chest because it's not stored inside your Cloud Vault...";
            const weighMessage = `Finally, asking Miss Aquarius™ AI to weigh the Karat for your Silver${
                this.data.b.d ? " and the Carat for your Diamonds" : ""
            }...`;

            switch (this.data.b.v) {
                case 0: // cloud
                    if (this.chest.code && this.chest.avatar) {
                        this.b1.render = "avatar";
                        this.b1.renderAvatar(this.data.f.p);
                        this.b1.classList.remove("hidden");
                        this.b1.style.display = "";
                        this.b2.classList.add("hidden");
                        this.b2.classList.remove("flex");
                        this.dialog.render1();
                    } else {
                        // for sharing gif
                        this.dialog.renderMessage(qrMessage);
                        this.chest.code = await this.gif.renderCode(
                            `${B}/v/${this.chest.id}`,
                            false,
                            !!this.data.b.s
                        );
                        this.dialog.render1a(true);
                        this.dialog.render1b(true);

                        // for link preview: SECOND ORDER is IMPORTANT
                        this.dialog.renderMessage(
                            "Now generating a unique Short Link for your Silver B-Chest for easy sharing..."
                        );
                        this.chest.avatar = await this.gif.renderAvatar(
                            this.chest.uid,
                            this.data.f.p,
                            !!this.data.b.s
                        );
                        this.dialog.render2a(true);
                        this.dialog.render2b(true);

                        this.dialog.renderMessage(weighMessage);
                        await this.chests.updateCloud(
                            this.chest,
                            this.chest.code,
                            this.chest.avatar
                        );

                        this.b1.classList.add("hidden");
                        this.b1.style.display = "none";
                        this.b2.classList.remove("hidden");
                        this.b2.classList.add("flex");
                        this.b.classList.remove("hidden");
                        this.b3.classList.add("hidden");

                        this.dialog.render3a(true);
                        this.dialog.render3b(true);
                    }

                    this.message.style.color = "gray";
                    this.message.textContent = this.renderMessage();
                    break;
                case 1: // code
                    if (this.chest.code) {
                        this.b1.render = "code";
                        this.b1.renderCode(this.chest.data);
                        this.b1.classList.remove("hidden");
                        this.b1.style.display = "";
                        this.b2.classList.add("hidden");
                        this.b2.classList.remove("flex");
                        this.dialog.render1();
                    } else {
                        this.dialog.renderMessage(qrMessage);
                        this.chest.code = await this.gif.renderCode(
                            this.chest.data,
                            true,
                            !!this.data.b.s
                        );
                        this.dialog.render1a(true);
                        this.dialog.render1b(true);

                        this.dialog.renderMessage(skipMessage);
                        await wait(1);
                        this.dialog.render2a(true);
                        await wait(1);
                        this.dialog.render2b(true);

                        this.dialog.renderMessage(weighMessage);
                        await this.chests.update(
                            this.chest.id,
                            this.chest.code
                        );
                        await wait(2);

                        this.b1.classList.add("hidden");
                        this.b1.style.display = "none";
                        this.b2.classList.remove("hidden");
                        this.b2.classList.add("flex");
                        this.b.classList.remove("hidden");
                        this.b3.classList.add("hidden");

                        this.dialog.render3a(true);
                        this.dialog.render3b(true);
                    }

                    this.message.style.color = "gray";
                    this.message.textContent = this.renderMessage();
                    break;
                case 2: // crystal
                    this.dialog.renderMessage(
                        "Now wrapping up your Silver B-Chest inside a 3B Crystal for easy sharing..."
                    );
                    const diamonds = await this.media.getFilesFromOPFS(
                        `chests/${this.chest.id}`
                    );
                    this.chest.crystal = isUSDZ
                        ? await this.B.mint(this.chest.data, diamonds)
                        : await this.B.mint2(this.chest.data, diamonds);
                    this.dialog.render1a(true);
                    this.dialog.render1b(true);

                    this.dialog.renderMessage(skipMessage);
                    await wait(1);
                    this.dialog.render2a(true);
                    await wait(1);
                    this.dialog.render2b(true);

                    this.dialog.renderMessage(weighMessage);
                    this.crystal.init();
                    this.crystal.isRainbow = false;
                    this.crystal.setKarat("silver");
                    this.crystal.startAnimation(!!this.data.b.s);
                    await wait(2);

                    this.b1.classList.add("hidden");
                    this.b1.style.display = "none";
                    this.b2.classList.remove("hidden");
                    this.b2.classList.add("flex");
                    this.b.classList.add("hidden");
                    this.b3.classList.remove("hidden");

                    this.dialog.render3a(true);
                    this.dialog.render3b(true);

                    this.message.style.color = "gray";
                    this.message.textContent = this.renderMessage();
                    break;
            }

            this.dialog.hide();
        }
    }

    hide() {
        this.modal.hide();
    }

    private bury() {}

    private async create() {
        if (confirm("Please provide a photo of the Gem's QR Code.")) {
            const file = await pickFile({ capture: "camera" });
            // Do something with the file
        }
    }

    //TODO: later tell user to create google group email for easy family chat!
    private async ship(previousInput: string = "") {
        const INFO = this.data.t
            ? "\n\n(Leave blank to only send to your recipients)"
            : "";
        const info =
            previousInput ||
            (isProduction ? "family@heartbank.ceo" : "thonly@heartbank.ceo");
        const input = prompt(
            previousInput
                ? "Please ensure all the email addresses are correct." + INFO
                : "Please enter the email addresses (comma-separated) to whom HeartBank® should send this Silver B-Chest on your behalf:" +
                      INFO,
            info
        );

        if (input !== null) {
            // || input === info

            const chest =
                this.data.b.v === 0
                    ? this.chest.id
                    : { name: this.chest.name, ...this.data };
            const blob =
                this.data.b.v === 0
                    ? null
                    : this.data.b.v === 1
                      ? this.chest.code
                      : this.chest.crystal;

            if (input.trim() === "") {
                if (this.data.t) {
                    await this.sendEmail(chest, blob, []);
                }
            } else {
                const addresses = this.parseAndValidateEmails(input);
                if (addresses) {
                    await this.sendEmail(chest, blob, addresses);
                } else {
                    await this.ship(input);
                }
            }
        }
    }

    async sendEmail(chest: any, blob: Blob | null, addresses: string[]) {
        this.main.showSpinner();
        const status = await this.functions.broadcast(chest, blob, addresses);
        status === "success"
            ? alert(
                  "HeartBank® has anonymously sent your Silver B-Chest on your behalf!"
              )
            : alert("Sorry, an error occured. Please try sending again.");
        this.main.hideSpinner();
    }

    // normalize and remove duplicates
    private parseAndValidateEmails(input: string): string[] | null {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        const emails = Array.from(
            new Set(
                input
                    .split(",")
                    .map((e) => e.trim().toLowerCase())
                    .filter((e) => e.length > 0)
            )
        );

        for (const email of emails) {
            if (!emailRegex.test(email)) {
                return null;
            }
        }

        return emails;
    }

    // sender sends themself publicly
    private async share() {
        const chest = new Chest(this.chest, this.data);
        const title = chest.getTitle();
        const jewel = new File(
            [await fetchBlob(this.chest.coverVideo)],
            `${this.chest.name}.B.mp4`,
            {
                type: "video/mp4"
            }
        );

        switch (this.data.b.v) {
            case 0: // cloud: link
                const avatar = new File(
                    [this.chest.avatar],
                    `${this.chest.name}.B.gif`,
                    {
                        type: "image/gif"
                    }
                );
                const code2 = new File(
                    [this.chest.code],
                    `${this.chest.name}.code.B.gif`,
                    {
                        type: "image/gif"
                    }
                );
                const link = `${B}/v/${this.chest.id}`;
                chest.isTimeLocked()
                    ? await this.shareFile(
                          chest.getTitle("timelock"),
                          await chest.getTimeLockText(),
                          link,
                          jewel
                      )
                    : await this.shareFile(
                          title,
                          await chest.getPublicText("cloud"), // :\n\n${link} // "🌎 Someone at Planet Fitness thanks Cheng"
                          link,
                          jewel //[avatar, code2] // can do this in hb-vault
                      );
                // //for link preview
                // downloadFile(
                //     `${this.chest.name}.avatar.B.gif`,
                //     this.chest.avatar
                // );
                // //for sharing gif
                // downloadFile(`${this.chest.name}.code.B.gif`, this.chest.code);
                break;
            case 1: // code
                const code = new File(
                    [this.chest.code],
                    `${this.chest.name}.B.gif`,
                    {
                        type: "image/gif"
                    }
                );
                await this.shareFiles(
                    title,
                    await chest.getPublicText("code"), // :\n\n${this.link}
                    this.link,
                    [jewel, code]
                );
                //downloadFile(`${this.chest.name}.B.gif`, this.chest.code);
                break;
            case 2: // crystal
                const name = `${this.chest.name}.3B.${isUSDZ ? "usdz" : "glb"}`;
                const crystal = new File([this.chest.crystal], name, {
                    type: isUSDZ ? "model/vnd.usdz+zip" : "model/gltf-binary"
                });
                await this.shareFiles(
                    title,
                    await chest.getPublicText("crystal"), // :\n\n${this.link}
                    this.link,
                    [jewel, crystal]
                );
                //downloadFile(name, this.chest.crystal);
                break;
        }
    }

    // sender as someone to forward on their behalf
    private async courier() {
        const chest = new Chest(this.chest, this.data);
        const title = chest.getTitle("courier");
        const jewel = new File(
            [await fetchBlob(this.chest.coverVideo)],
            `${this.chest.name}.B.mp4`,
            {
                type: "video/mp4"
            }
        );

        switch (this.data.b.v) {
            case 0: // cloud: link
                const avatar = new File(
                    [this.chest.avatar],
                    `${this.chest.name}.B.gif`,
                    {
                        type: "image/gif"
                    }
                );
                const code2 = new File(
                    [this.chest.code],
                    `${this.chest.name}.code.B.gif`,
                    {
                        type: "image/gif"
                    }
                );
                const link = `${B}/v/${this.chest.id}`;
                chest.isTimeLocked()
                    ? await this.shareFile(
                          chest.getTitle("both"),
                          await chest.getTimeLockText(false),
                          link,
                          jewel
                      )
                    : await this.shareFile(
                          title,
                          await chest.getAnonymousText("cloud"), // :\n\n${link} // "🌎 Someone at Planet Fitness thanks Cheng"
                          link,
                          jewel //[avatar, code2] // can do this in hb-vault
                      );
                // //for link preview
                // downloadFile(
                //     `${this.chest.name}.avatar.B.gif`,
                //     this.chest.avatar
                // );
                // //for sharing gif
                // downloadFile(`${this.chest.name}.code.B.gif`, this.chest.code);
                break;
            case 1: // code
                const code = new File(
                    [this.chest.code],
                    `${this.chest.name}.B.gif`,
                    {
                        type: "image/gif"
                    }
                );
                await this.shareFiles(
                    title,
                    await chest.getAnonymousText("code"), // :\n\n${this.link}
                    this.link,
                    [jewel, code]
                );
                //downloadFile(`${this.chest.name}.B.gif`, this.chest.code);
                break;
            case 2: // crystal
                const name = `${this.chest.name}.3B.${isUSDZ ? "usdz" : "glb"}`;
                const crystal = new File([this.chest.crystal], name, {
                    type: isUSDZ ? "model/vnd.usdz+zip" : "model/gltf-binary"
                });
                await this.shareFiles(
                    title,
                    await chest.getAnonymousText("crystal"), // :\n\n${this.link}
                    this.link,
                    [jewel, crystal]
                );
                //downloadFile(name, this.chest.crystal);
                break;
        }
    }

    //// helpers

    private async shareFile(
        title: string,
        text: string,
        url: string,
        file: File
    ) {
        await this.shareFiles(title, text, url, [file]);
    }

    private async shareFiles(
        title: string,
        text: string,
        url: string,
        files: File[]
    ) {
        const shareData = {
            title,
            text:
                title +
                "\n\n" +
                text +
                "\n\nThank with HeartBank®\nWhatsApp: +1 (800) 59-THANK\n",
            url,
            files
        };
        //console.log(shareData);

        if (navigator.canShare && navigator.canShare(shareData)) {
            try {
                await navigator.share(shareData);
                // this.message.style.color = "green";
                // this.message.textContent = "Shipped successfully";
                console.log("Shipped successfully");
            } catch (error: any) {
                console.log(error);
                if (
                    error.name === "AbortError" ||
                    error.name === "InvalidStateError"
                ) {
                    // this.message.style.color = "orange";
                    // this.message.textContent =
                    //     "Sharing was cancelled: " + error.message;
                    console.warn("Sharing was cancelled: ", error);
                } else {
                    // this.message.style.color = "red";
                    // this.message.textContent =
                    //     "Sorry, Web Share is not supported for this file type.";
                    for (const file of files) downloadFile(file.name, file); //FIXED: weird bug: triggered sometimes when not a crystal
                    this.message.style.color = "green";
                    this.message.textContent =
                        "This Silver 3B Crystal has been downloaded to your device for sharing.";
                }
            }
        } else {
            this.message.style.color = "orange";
            this.message.textContent =
                "Sorry, Web Share is not supported on this device.";
        }
    }
}
